import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import config from '../config';
import { contentType } from '../constants/global';
import Breadcrumb from '../components/Brand/Shared/Breadcrumb';
import PageMetadata from '../components/Generic/PageMetadata';
import PGDataLayer from '../components/Generic/PGDataLayer/PGDataLayer';
import DOMIdentifier from '../utils/domIdentifier';
import styles from '../components/Brand/Layout/common-tw-styles';

class ContactUs extends React.Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    router: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  static async getInitialProps({ query }) {
    return {
      pageContext: query,
    };
  }

  componentDidMount() {
    DOMIdentifier.addClassToBody('contact-us');
  }

  componentWillUnmount() {
    DOMIdentifier.removeClassToBody('contact-us');
  }

  render() {
    const { pageContext, router } = this.props;
    const constants =
      pageContext.locale !== null
        ? require(`../constants/messages/${pageContext.locale}`)
        : null;
    return (
      <React.Fragment>
        <PGDataLayer
          locale={pageContext.locale}
          pageType={contentType.contentPage}
          path={router.asPath}
          title={constants.contact_metaTitle}
        />
        {constants && (
          <PageMetadata
            title={constants.contact_metaTitle}
            metaTitle={constants.contact_metaTitle}
            metaDescription={constants.contact_metaDescription}
          />
        )}
        <h1 className={styles.hiddenClass}>contacte-nos</h1>
        <div className={styles.faqContactContainer}>
          <Breadcrumb locale={pageContext.locale} currentUrl={router.asPath} />
        </div>
        <div className={styles.faqContact}>
          <div className={styles.faqContactMain}>
            <div className={styles.faqContactdiv}>
              {pageContext.locale && (
                <iframe
                  title="pgcontactus"
                  className={styles.faqContactIframe}
                  src={config.contactUs[pageContext.locale].iframeLink}
                  width="100%"
                  height="558px"
                  data-autosize="disabled"
                />
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(ContactUs);
